import styled from 'styled-components';
import { useTranslation, withTranslation } from 'react-i18next';
import { Typography } from 'antd';
import { Button } from '@/components/common/atoms';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';

export const FooterButtons = withTranslation()(
  ({
     onNext,
     onBack,
     NextButtonTitle = 'Next',
     withoutArrow = false,
     nextDisabled = false,
     hideBack = false,
     hideNext = false,
     noMargin = false,
     isShowTotalPoints,
     totalPoints
   }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
      <ButtonsContainer $noMargin={noMargin}>
        {!hideBack && (
          <Button
            text={t('Back')}
            onClick={() => {
              onBack ? onBack() : navigate(-1);
            }}
            hide={hideBack}
          />
        )}

        {isShowTotalPoints && totalPoints !== null && (
          <TotalScoreText>
            {t('Final risk score:')} {totalPoints}
          </TotalScoreText>
        )}

        {!hideNext && onNext && (
          <Button
            label={t(NextButtonTitle)}
            type='primary'
            icon={withoutArrow ? null : <ArrowLeftOutlined />}
            onClick={!nextDisabled ? onNext : null}
            disabled={nextDisabled}
          />
        )}
      </ButtonsContainer>
    );
  }
);

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
  ${(p) => (!p.$noMargin ? 'margin-top: 34px;' : '')}
`;

const TotalScoreText = styled(Typography.Text)`
  font-size: 16px;
`;
